import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TOKEN_TABS, type TokenTab } from '@/features/access/access-tabs';
import { TokenDetailPage } from '@/features/access/tokens/token-detail-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Jeton d'agent (`/identities/{id}`). L'onglet actif vit dans l'URL (`?tab=rights`). */
export const Route = createFileRoute('/$tenant/tokens/agents/$identityId')({
  validateSearch: (search: Record<string, unknown>): { tab: TokenTab } => ({
    tab: TOKEN_TABS.parse(search['tab']),
  }),
  component: AgentTokenRoute,
});

function AgentTokenRoute() {
  const { tenant, identityId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="tokens"
      crumbs={[{ label: t('access.tokens.title') }, { label: identityId, mono: true }]}
    >
      <TokenDetailPage
        tenantId={tenant}
        kind="agent"
        tokenId={identityId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
